import { CompDateTimePickerCore } from '../core/forms/datetime-picker/comp'

export const CompDateTimePicker = CompDateTimePickerCore
